import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-around p-flex-wrap" }
const _hoisted_2 = {
  autocomplete: "off",
  spellcheck: "false"
}
const _hoisted_3 = { class: "p-mt-1 p-ml-1" }
const _hoisted_4 = {
  key: 0,
  class: "p-error p-m-0"
}
const _hoisted_5 = { class: "p-inputgroup p-mt-3" }
const _hoisted_6 = { class: "p-inputgroup-addon" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user p-mr-1" }, null, -1)
const _hoisted_8 = { class: "p-inputgroup p-my-3" }
const _hoisted_9 = { class: "p-inputgroup-addon" }
const _hoisted_10 = { class: "p-inputgroup p-mb-2" }
const _hoisted_11 = { class: "p-inputgroup-addon" }
const _hoisted_12 = {
  class: "p-text-left p-m-0",
  style: {"width":"100%"}
}
const _hoisted_13 = { class: "p-d-flex p-jc-between" }
const _hoisted_14 = {
  class: "p-mt-2",
  style: {"color":"var(--primary-color)"}
}
const _hoisted_15 = { style: {"font-size":"2em","font-weight":"bolder"} }
const _hoisted_16 = {
  class: "p-text-center",
  style: {"font-size":"5em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_SplitterPanel = _resolveComponent("SplitterPanel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Splitter = _resolveComponent("Splitter")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:visible', $event))),
      header: 
      _ctx.$t(`payment.title${_ctx.ticket?.payments?.length ? 'Remain' : ''}`, {
        number: _ctx.ticket ? _ctx.$t('ticket.number', { number: _ctx.ticket?.number }) : '',
      })
    ,
      breakpoints: { '960px': '97vw' },
      style: { width: '550px' },
      onHide: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetFields())),
      onShow: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onActivePrinter(null))),
      modal: true
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_ToggleButton, {
            onIcon: "pi pi-print",
            offIcon: "pi pi-print",
            class: "p-px-3",
            "model-value": _ctx.print,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.onActivePrinter($event)))
          }, null, 8, ["model-value"]),
          _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.$tm("payment.printer")[_ctx.print ? 0 : 1]), 1),
          _createVNode(_component_Button, {
            loading: _ctx.loading,
            icon: "pi pi-check",
            class: "p-button-secondary p-px-3",
            disabled: _ctx.control.disable || _ctx.loading,
            onClick: _ctx.onValidate
          }, null, 8, ["loading", "disabled", "onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("h6", _hoisted_1, [
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("payment.total")) + " : ", 1),
            _createVNode(_component_NumberFormatter, {
              value: _ctx.resume.total - _ctx.discount
            }, null, 8, ["value"]),
            _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
          ]),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("payment.remain")) + " : " + _toDisplayString(_ctx.summary.remain) + " " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
        ]),
        _createElementVNode("form", _hoisted_2, [
          _createVNode(_component_Splitter, { layout: "horizontal" }, {
            default: _withCtx(() => [
              _createVNode(_component_SplitterPanel, {
                size: 18,
                class: "p-d-flex p-px-2 p-flex-column p-ai-center p-jc-center"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('payment.methods'), (method, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "p-inputgroup p-m-2",
                      key: index
                    }, [
                      _createVNode(_component_InputSwitch, {
                        "false-value": null,
                        "onUpdate:modelValue": ($event: any) => (_ctx.setMethod(index)),
                        trueValue: index,
                        "model-value": _ctx.form.method.$value,
                        disabled: index === 4 && _ctx.ticket?.status === 1
                      }, null, 8, ["onUpdate:modelValue", "trueValue", "model-value", "disabled"]),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(method), 1)
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_SplitterPanel, { class: "p-d-flex p-flex-column p-px-2 p-ai-center p-jc-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_BlockUI, {
                    blocked: [3, 4].includes(_ctx.form.method.$value)
                  }, {
                    default: _withCtx(() => [
                      (_ctx.control.creditWithNoCustomer)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t("payment.forbidden")), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, [
                          _hoisted_7,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("payment.customer")), 1)
                        ]),
                        _createVNode(_component_InputText, {
                          disabled: "",
                          class: "p-text-right",
                          "model-value": 
                  _ctx.ticket?.customer?.name ||
                  _ctx.customer?.name ||
                  _ctx.$t('payment.clientUndefined')
                
                        }, null, 8, ["model-value"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("payment.received")), 1),
                        _createVNode(_component_InputNumber, {
                          "input-class": "p-text-right",
                          "model-value": _ctx.form.received.$value,
                          locale: _ctx.numberSeparators[_ctx.activeActivity.separator],
                          "max-fraction-digits": 20,
                          "allow-empty": true,
                          min: 0,
                          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.form.received.$value = Number($event.value))),
                          autofocus: "",
                          onfocus: "setTimeout(() => this.select(), 100)"
                        }, null, 8, ["model-value", "locale"])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("payment.change")), 1),
                        _createVNode(_component_InputNumber, {
                          "input-class": "p-text-right",
                          "model-value": _ctx.summary.change,
                          locale: _ctx.numberSeparators[_ctx.activeActivity.separator],
                          "max-fraction-digits": _ctx.activeActivity.decimalNumber,
                          disabled: true
                        }, null, 8, ["model-value", "locale", "max-fraction-digits"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["blocked"]),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("payment.note")), 1),
                  _createVNode(_component_Textarea, {
                    class: "p-mb-3",
                    style: {"width":"100%"},
                    modelValue: _ctx.form.note.$value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.note.$value) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"]),
    (_ctx.dialogChange.show)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          closable: false,
          visible: _ctx.dialogChange.show
        }, {
          header: _withCtx(() => [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("payment.change")), 1)
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              style: {"font-size":"1.5em","width":"100%"},
              loading: _ctx.loading,
              disbled: _ctx.loading,
              label: _ctx.$t('ok'),
              icon: "pi pi-check",
              "icon-pos": "right",
              class: "p-button-info p-px-3 p-button-rounded",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogChange.show = false))
            }, null, 8, ["loading", "disbled", "label"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_NumberFormatter, {
                value: _ctx.dialogChange.value
              }, null, 8, ["value"]),
              _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
            ])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ], 64))
}